import React, {useState, useRef, useEffect} from 'react';
import {useRouter} from 'next/router';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/review/AccountReview.module.scss';
import ErrorMessage from '../../elements/ErrorMessage';
import Loading from '../../elements/Loading';
import UserReviewGroup from './UserReviewGroup';
import Spinner from 'react-bootstrap/Spinner';
import Dialog from '../../elements/Dialog';
import { reset } from '../../login/userSlice';

const UserReviewList = (props) => {
    const router = useRouter();
    const {manageReview} = props;
    const ItemsPerPage = 5;
    const [reviews, editReviews] = useState([]);
    const [page, editPage] = useState(1);
    const [items, editItems] = useState(false);
    const [error, editError] = useState(false);
    const [isLoading, editIsLoading] = useState(true);
    const [isLoadingMore, editIsLoadingMore] = useState(false);
    const [showDialog, editShowDialog] = useState(false);
    const [deleteResponse, editDeleteResponse] = useState(false);
    const isMounted = useRef(null);
    const dispatch = useDispatch();

    useEffect(
        ()=>{
            isMounted.current = true;
            loadReviews(page);
            return ()=>{
                isMounted.current = false;
            }
        }, []
    )

    const handleManageReview = () => {
        manageReview(0);
    };

    const addReview =   <div className={`mt-3 py-3 text-center bg-white ${styles.boxWrapper}`}>
                            <p>Ce experienta ai avut cu serviciile financiare?</p>
                            <Button variant="secondary" onClick={handleManageReview} >
                                <FontAwesomeIcon icon={faPlus} height="16" width="16" className="me-2"/>
                                Adaugă recenzie
                            </Button>
                        </div>;


    const errorNotification = <ErrorMessage title="Eroare" message={error} />;

    const loadReviews = async (page) => {
        try {
            if (page>1) {
                editIsLoadingMore(true);
            }
            let url = process.env.NEXT_PUBLIC_API + '/api/user/review/list';
            let response = await axios({
                method: 'get',
                url: url,
                params: {page: page, items: ItemsPerPage},
                headers: {'Content-Type': 'application/json'},
                withCredentials: true,
            });
            let data = response.data;
           
            if (isMounted.current) {
              
                if (data.status) {
                    let newPage = {
                        page: page,
                        list: data.list
                    };
                    let newReviews = reviews.length==0 ? [newPage] : [...reviews, newPage];
                    editReviews(newReviews);
                    editItems(data.totalReviews);
                    if (page>1) {
                        editPage(page);
                    }
                } else {
                    if (data.hasOwnProperty('error')) {
                        if (data.error == 'login') {
                            dispatch(reset());
                        } else {
                            editError("Te rugăm sa încerci mai târziu.");
                        }
                       
                    }
                }
                if (page==1) {
                    editIsLoading(false);
                }
                
                if (page>1) {
                    editIsLoadingMore(false);
                }
            }
        } catch(err) {
            editError("Te rugăm sa încerci mai târziu.");
            editIsLoading(false);
        }
    }

    const getMoreReviews = () => {
        loadReviews(page+1);
    }

    const moreButton = <Col className="text-center">
                            { isLoadingMore ?                         
                                <Spinner animation="border" className="green my-3" />                         
                            :
                            <Button variant="outline-secondary" className="mb-5" onClick={getMoreReviews} >
                               Mai multe recenzii     
                            </Button>
                            }
                        </Col> ;


    let moreReviews =  items && ( items > page * ItemsPerPage ? moreButton
                                :
                                <p className="text-muted">Ai ajuns la finalul recenziilor.</p>
                                );

    const closeDialog = ()=> {editShowDialog(false)};
    const openDialog = (id) => {editDeleteResponse(false); editShowDialog(id)};

    const reviewList =  <Row className="mt-5 g-0">                    
                            <h2 className={`${styles.topic} py-3`} >Recenzii postate</h2>
                            { reviews.map( r =>
                                    <UserReviewGroup 
                                        key={r.page} 
                                        page={r.page} 
                                        list={r.list} 
                                        editReview={manageReview} 
                                        handleDelete={openDialog}
                                    />
                                )
                            }
                            {moreReviews}
                        </Row>;

    const noReview = !isLoading && !error && reviews.length==0 &&
                            <Col xs="12" className="mt-3">
                                <p>Nu ai postat încă nicio recenzie.</p>
                        </Col>;

    const showReviews = reviews.length > 0 ? reviewList : noReview;

    const deleteReview = async(id) =>{
        try {
            const url = process.env.NEXT_PUBLIC_API + '/api/user/review/delete';
            const response = await axios({
                url: url, 
                method: 'post',
                data: {
                    id: id
                },
                withCredentials: true,
                headers: {'Content-Type': 'application/json'},
            });
        
            let data = response.data;
            if (isMounted.current) {
                if (data.status) {
                    //succes
                    let newReviews = reviews;
                    for(let i=0; i<page; i++) {
                        let findReview = reviews[i].list.findIndex( r => r.id == id);
                        if (findReview > -1) {
                           newReviews[i].list.splice(findReview, 1);
                        }
                    }
                    editReviews(newReviews);
                } else {
                    if (data.hasOwnProperty('error') ) {
                        if (data.error == 'login') {
                            router.push('/login');
                        }
                    }
                }
                editDeleteResponse(data.message);
            }

        } catch(err){
           
            editDeleteResponse("Eroare: Te rugăm să încerci mai târziu");
        }
    }

   

    return (
    <>
        <Row>
            <Col lg={8} xs={12} className="mx-auto">
                <h1 className="heading1 py-3 font-weight-bold text-center black-text">
                    Recenzii
                </h1>
            </Col>
        </Row>
        <Row>
            <Col lg={8} xs={12} className="mx-auto">
            {addReview}
            {isLoading ? <Loading /> : showReviews}
            {error && errorNotification}
            </Col>
        </Row>
        {showDialog && 
            <Dialog 
                showResponse={false}
                question="Ești sigur că vrei să ștergi recenzia?"
                actionTitle="Șterge"
                cancelTitle="Anulează"
                action={deleteReview}
                cancel={closeDialog}
                param={showDialog}
                response={deleteResponse}
                
            />
        }
    </>
    );
}

export default UserReviewList;